<script setup lang="ts">
import { onMounted,onBeforeUnmount,ref,reactive } from 'vue'
import ModalDialog from "../../compositions/ModalDialog.vue";
import CustomEvent from "../../compositions/CustomEvent.vue";
import CustomList from "../../compositions/CustomList.vue";
import TextBox from "../../compositions/TextBox.vue";
import SelectBox from "../../compositions/SelectBox.vue";
import config from "../../config.js";
import { successAlert,errorAlert,confirmAlert } from "../../plugins/alert";
import qs from 'qs';
import axios from '../../plugins/axios.ts';
import Breakpoint from '../../compositions/Breakpoint.vue';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    csrfToken:{
      type:String,
      required:true,
    },
    alert:{
      type:Object,
      required:true,
    },
    isAdmin:{
      type:Boolean,
      default: () => {
        return false;
      },
    },
    pharmacyProfile:{
      type:Object,
      required:true
    },
    userName:{
      type:String,
      required:true,
    },
    logoutUrl:{
      type:String,
      required:true,
    },
    passwordChangeUrl:{
      type:String,
      required:true,
    },
})

const listRef = ref();
const isLoadingDialog = ref(false);
const isExpended = ref(false);
const isOpen = ref(false);
const isStaffListDialog = ref(false);
const selectStaffId = ref(0);
const staffName = ref("");
const staffEmail = ref("");
const staffPassword = ref("");
const staffPasswordConfirm = ref("");
const isStaffPasswordExpand = ref(false);
const isStaffEditDialogLoading = ref(false);
const isPharmacyProfileDialog = ref(false);
const isPharmacyProfileEditDialogLoading = ref(false);
const establishPermitFile = ref(new Object());
const pharmacyAlert = reactive(props.alert)
const establishPermitUploadDate = ref(props.pharmacyProfile.establish_permit_upload_date);
const establishPermitExpireDate = ref(props.pharmacyProfile.establish_permit_expire_date);
const establishPermitNumber = ref(props.pharmacyProfile.establish_permit_number);
const invoiceNumber = ref(props.pharmacyProfile.invoice_number);
const expensiveLimitUnitPrice = ref(props.pharmacyProfile.expensive_limit_unit_price);
const oldMedicineJudgeDay = ref(props.pharmacyProfile.old_medicine_judge_day);
const learningResultDaySetting = ref(props.pharmacyProfile.learning_result_day_setting);
const listSearch = (delay=0) => {
  listRef.value.resetItem(delay);
}
const showStaffListDialog = () => {
  isStaffListDialog.value = true;
}
const closeStaffListDialog = () => {
  isStaffListDialog.value = false;
}

const staffListDialogReset = () => {
  //
}
const updateStaff = async () => {
  if (staffName.value.length == 0) {
    errorAlert('スタッフ名は必須です。');
    return;
  }
  if (staffEmail.value.length == 0) {
    errorAlert('メールアドレスは必須です。');
    return;
  }
  if (isStaffPasswordExpand.value) {
    if (staffPassword.value.length == 0) {
      errorAlert('パスワードは必須です。');
      return;
    }
    if (staffPasswordConfirm.value.length == 0) {
      errorAlert('確認用パスワードは必須です。');
      return;
    }
    if (staffPassword.value != staffPasswordConfirm.value) {
      errorAlert('確認用パスワードが異なります。');
      return;
    }
  }
  let params = new FormData();
  params.append('id', selectStaffId.value);
  params.append('username', staffName.value);
  params.append('email', staffEmail.value);
  params.append('password', (isStaffPasswordExpand ? staffPassword.value : ''));
  params.append('password_confirm', (isStaffPasswordExpand ? staffPasswordConfirm.value : ''));
  isStaffEditDialogLoading.value = true;
  try {
    const response = await axios(props.apis.user_pharmacy_update_staff,{method:"post",data:params});
    if (response.data.status == 200) {
      listSearch(config.LIST_DELAY);
      closeStaffEditDialog();
    }
  } finally {
    isStaffEditDialogLoading.value = false;
  }
}
const deleteStaffConfirm = async (id) => {
  let result = await confirmAlert('スタッフを削除してもよろしいですか？');
  if (result.isConfirmed) {
    deleteStaff(id);
  }
}
const deleteStaff = async (id) => {
  let params = new FormData();
  params.append('id', id);
  isStaffEditDialogLoading.value = true;
  try {
    const response = await axios(props.apis.user_pharmacy_delete_staff,{method:"post",data:params});
    if (response.data.status == 200) {
      listSearch(config.LIST_DELAY);
      closeStaffEditDialog();
    }
  } finally {
    isStaffEditDialogLoading.value = false;
  }
}
const isStaffEditDialog = ref(false);
const showStaffEditDialog = (user) => {
  selectStaffId.value = 0;
  isStaffEditDialog.value = true;
  isStaffPasswordExpand.value = true;
  staffName.value = "";
  staffEmail.value = "";
  staffPassword.value = "";
  staffPasswordConfirm.value = "";
  if (user != null) {
    selectStaffId.value = user.id;
    isStaffPasswordExpand.value = false;
    staffName.value = user.username;
    staffEmail.value = user.email;
  }
}
const closeStaffEditDialog = () => {
  isStaffEditDialog.value = false;
}

const showPharmacyProfileDialog = () => {
  isPharmacyProfileDialog.value = true;
}
const closePharmacyProfileDialog = () => {
  isPharmacyProfileDialog.value = false;
}
const onChangeEstablishPermitNumber = (value) => {
  establishPermitNumber.value = value;
}
const onChangeEstablishPermitExpireDate = (value) => {
  establishPermitExpireDate.value = value;
}
const onChangeInvoiceNumber = (value) => {
  invoiceNumber.value = value;
}
const onChangeLearningResultDaySetting = (value) => {
  learningResultDaySetting.value = value;
}
const onFileUpload = (e) => {
  establishPermitFile.value = e.target.files[0];
}
const onProfileTextChange = (value,option) => {
  if (option.type == 'expensive_limit_unit_price') {
    expensiveLimitUnitPrice.value = value;
  } else if (option.type == 'old_medicine_judge_day') {
    oldMedicineJudgeDay.value = value;
  }
}
const updatePharmacyProfile = async () => {
  let params = new FormData();
  params.append('establish_permit_file', establishPermitFile.value);
  params.append('establish_permit_expire_date', establishPermitExpireDate.value);
  params.append('establish_permit_number', establishPermitNumber.value);
  params.append('invoice_number', invoiceNumber.value);
  params.append('expensive_limit_unit_price',expensiveLimitUnitPrice.value);
  params.append('old_medicine_judge_day',oldMedicineJudgeDay.value);
  params.append('learning_result_day_setting',learningResultDaySetting.value);
  isPharmacyProfileEditDialogLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_profile_update,{method:"post",data:params});
    if (response.data.status == 200) {
      establishPermitUploadDate.value = response.data.data.establish_permit_upload_date;
      if (establishPermitFile.value && establishPermitExpireDate.value && establishPermitNumber.value) {
        pharmacyAlert.alert_profiles = 0;
        pharmacyAlert.alert_establish_permit_upload_date = 0;
      }
      closePharmacyProfileDialog();
    }
  } finally {
    isPharmacyProfileEditDialogLoading.value = false;
  }
}

const isTotpSettingDialog = ref(false);
const isTotpSettingLoading = ref(false);
const totpEnabled = ref(false);
const totpQrCode = ref('');
const totpSecret = ref('');
const totpCode = ref('');
const isTotpSetupStarted = ref(false);
const showTotpSettingDialog = async () => {
  isTotpSettingDialog.value = true;
  isTotpSetupStarted.value = false;
  totpQrCode.value = '';
  totpSecret.value = '';
  totpCode.value = '';
  isTotpSettingLoading.value = true;
  try {
    const response = await axios(props.apis.user_totp_setting,{method:"get"});
    totpEnabled.value = response.data.data.enabled;
  } finally {
    isTotpSettingLoading.value = false;
  }
}
const closeTotpSettingDialog = () => {
  isTotpSettingDialog.value = false;
}
const onChangeTotpCode = (value) => {
  totpCode.value = value;
}
const startTotpSetup = async () => {
  isTotpSettingLoading.value = true;
  try {
    const response = await axios(props.apis.user_totp_generate,{method:"post"});
    if (response.data.status == 200) {
      totpQrCode.value = response.data.data.qr_code;
      totpSecret.value = response.data.data.secret;
      isTotpSetupStarted.value = true;
    } else {
      errorAlert(response.data.message);
    }
  } finally {
    isTotpSettingLoading.value = false;
  }
}
const enableTotp = async () => {
  if (totpCode.value.length == 0) {
    errorAlert('認証コードを入力してください。');
    return;
  }
  let params = new FormData();
  params.append('code', totpCode.value);
  isTotpSettingLoading.value = true;
  try {
    const response = await axios(props.apis.user_totp_enable,{method:"post",data:params});
    if (response.data.status == 200) {
      totpEnabled.value = true;
      isTotpSetupStarted.value = false;
      totpCode.value = '';
      successAlert('二段階認証を有効にしました。');
    } else {
      errorAlert(response.data.message);
    }
  } finally {
    isTotpSettingLoading.value = false;
  }
}
const disableTotpConfirm = async () => {
  if (totpCode.value.length == 0) {
    errorAlert('認証コードを入力してください。');
    return;
  }
  let result = await confirmAlert('二段階認証を無効にしますか？');
  if (result.isConfirmed) {
    disableTotp();
  }
}
const disableTotp = async () => {
  let params = new FormData();
  params.append('code', totpCode.value);
  isTotpSettingLoading.value = true;
  try {
    const response = await axios(props.apis.user_totp_disable,{method:"post",data:params});
    if (response.data.status == 200) {
      totpEnabled.value = false;
      totpCode.value = '';
      successAlert('二段階認証を無効にしました。');
    } else {
      errorAlert(response.data.message);
    }
  } finally {
    isTotpSettingLoading.value = false;
  }
}
const clickMenu = () => {
  if (isExpended.value == false) {
    isOpen.value = true;
  }
  isExpended.value = !isExpended.value;
}
const closeMenu = () => {
  if (isOpen.value == true) {
    isOpen.value = false;
    return;
  }
  isExpended.value = false;
}
const isEstablisheExpireDateDialog = ref(false);
const showEstablishExpireDateAlert = () => {
  isEstablisheExpireDateDialog.value = true;
}
const closeEstablishExpireDateAlert = () => {
  isEstablisheExpireDateDialog.value = false;
}
const logout = () => {
  document.getElementById('logout-form').submit();
  return true;
}
const {element,clickOutside} = CustomEvent(closeMenu)
onBeforeUnmount(() => {
  window.removeEventListener('click', clickOutside);
});
onMounted(() => {
  window.addEventListener('click', clickOutside);
  window.addEventListener('click', closeMenu);
  if (pharmacyAlert.alert_establish_permit_expire_date) {
    showEstablishExpireDateAlert();
  }
});
// モバイルのみ表示する為のstatus
const isMobile: boolean = Breakpoint().isBelow('sm');

</script>

<style scoped>
</style>
<template>
<div ref="element">
  <!-- Profile -->
  <div class="ml-3">
    <button type="button" class="relative w-7	h-7 md:w-auto md:h-auto flex items-center text-sm bg-amber-500 rounded-full focus:ring-4 focus:ring-amber-300" id="user-menu-button-2" aria-expanded="false" data-dropdown-toggle="dropdown-user" data-dropdown-placement="bottom" @click="clickMenu">
      <span class="w-7 md:w-full text-white text-xs md:text-lg py-2 px-2 md:px-4">{{ isMobile ? userName[0] : userName }}</span>
      <div v-show="pharmacyAlert.alert_profiles" class="inline-flex absolute -top-3.5 -right-3.5 md:-top-1 md:-right-1 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-red-700 rounded-full border-2 border-white dark:border-gray-900"><i class="fa-solid fa-triangle-exclamation"></i></div>
    </button>
    <!-- Dropdown menu -->
    <div v-show="isExpended" class="absolute right-0 z-50 my-4 text-base list-none bg-white rounded divide-y divide-gray-100 shadow" id="dropdown-user">
      <div class="py-3 px-4" role="none">
        <p class="text-sm font-medium text-gray-900 truncate" role="none">
        {{ userName }}
        </p>
      </div>
      <ul class="py-1" role="none">
        <li>
          <a :href="passwordChangeUrl" class="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100" role="menuitem">パスワード変更</a>
        </li>
        <li>
          <a href="javascript:void(0)" @click="showTotpSettingDialog" class="w-full block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100" role="menuitem">二段階認証設定</a>
        </li>
        <li v-show="isAdmin">
          <a href="javascript:void(0)" @click="showStaffListDialog" class="w-full block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100" role="menuitem">スタッフ編集</a>
        </li>
        <li v-show="isAdmin" class="relative">
          <a href="javascript:void(0)" @click="showPharmacyProfileDialog" class="w-full block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100" role="menuitem">薬局情報編集</a>
          <span v-show="pharmacyAlert.alert_establish_permit_upload_date" class="inline-flex absolute top-1 right-1 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-red-700 rounded-full border-2 border-white dark:border-gray-900"><i class="fa-solid fa-triangle-exclamation"></i></span>
        </li>
        <li>
          <form class="" method="POST" :action="logoutUrl" id="logout-form">
            <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken">
            <a href="javascript:void(0)" class="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100" role="menuitem" @click="logout">ログアウト</a>
          </form>
        </li>
      </ul>
    </div>
  </div>
</div>
<modal-dialog
  :is-visible="isLoadingDialog"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isStaffEditDialog"
  :close="closeStaffEditDialog"
  width="50%"
  :isLoading="isStaffEditDialogLoading"
>
  <template v-slot:header>
    スタッフ編集
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <table class="w-full">
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">スタッフ名 <span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span></th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" v-model="staffName">
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">メールアドレス <span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span></th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" v-model="staffEmail" placeholder="">
        </td>
      </tr>
      <tr v-show="selectStaffId != 0" class="border-b border-white">
        <td colspan="2" class="text-center">
          <span @click="isStaffPasswordExpand = !isStaffPasswordExpand" class="cursor-pointer">パスワード設定 {{ (isStaffPasswordExpand ? '△' : '▽') }}</span>
        </td>
      </tr>
      <tr v-show="selectStaffId == 0 || isStaffPasswordExpand" class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">パスワード <span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span></th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="password" v-model="staffPassword" placeholder="">
        </td>
      </tr>
      <tr v-show="selectStaffId == 0 || isStaffPasswordExpand" class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">確認用パスワード <span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span></th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="password" v-model="staffPasswordConfirm" placeholder="">
        </td>
      </tr>
    </table>

    <div class="flex">
      <div class="flex-row mr-2">
        <button type="button" @click="updateStaff" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">登録する</button>
      </div>
      <div class="flex-row">
        <button type="button" @click="closeStaffEditDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
      </div>
    </div>
  </div>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isStaffListDialog"
  :close="closeStaffListDialog"
  width="30%"
>
  <template v-slot:header>
    スタッフリスト
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <custom-list
      ref="listRef"
      :api-url="apis.user_pharmacy_staff_list"
      :reset="staffListDialogReset"
      width="100%"
    >
    <template v-slot:item="slotProps">
      <div class="flex justify-between items-center">
        <div class="flex-row text-lg text-left">
          {{ slotProps.item.user.username }}
        </div>
        <div class="flex flex-row text-right">
          <div class="flex-row mr-2" @click="showStaffEditDialog(slotProps.item.user)">
            <i class="fa-regular fa-pen-to-square text-lg"></i>
          </div>
          <div class="flex-row" @click="deleteStaffConfirm(slotProps.item.user.id)">
            <i class="fa-sharp fa-regular fa-circle-xmark text-lg"></i>
          </div>
        </div>
      </div>
    </template>
    </custom-list>
    <div>
      <button type="button" @click="showStaffEditDialog(null)" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">新規追加</button>
    </div>
  </div>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isPharmacyProfileDialog"
  :close="closePharmacyProfileDialog"
  width="50%"
  :isLoading="isPharmacyProfileEditDialogLoading"
>
  <template v-slot:header>
    薬局情報編集
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <p class="text-red-600">許可書の有効期限が切れている場合は、都度アップロードしてください。</p>
    <table class="w-full">
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">開設許可証</th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="file" @change="onFileUpload">
          <p>前回アップロード日時：{{ establishPermitUploadDate }}</p>
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">開設許可証番号</th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <text-box
            type="text"
            :value="establishPermitNumber"
            :on-change="onChangeEstablishPermitNumber"
          ></text-box>
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">開設許可証有効期限</th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <text-box
            type="date"
            :value="establishPermitExpireDate"
            :on-change="onChangeEstablishPermitExpireDate"
          ></text-box>
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">適格請求書発行事業者登録番号</th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <text-box
            type="text"
            :value="invoiceNumber"
            :on-change="onChangeInvoiceNumber"
          ></text-box>
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">単価アラート設定</th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <text-box
            :value="expensiveLimitUnitPrice"
            type="number"
            :value-options="{type:'expensive_limit_unit_price'}"
            :is-focus-clear="true"
            :on-change="onProfileTextChange"
          ></text-box>
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">不動在庫判定日数</th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <text-box
            :value="oldMedicineJudgeDay"
            type="number"
            :value-options="{type:'old_medicine_judge_day'}"
            :is-focus-clear="true"
            :on-change="onProfileTextChange"
          ></text-box>
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">予測期間設定</th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <select-box
            :value="learningResultDaySetting"
            :options="[{id:8,name:'8日'},{id:14,name:'14日'},{id:21,name:'21日'}]"
            list-field-name="name"
            :on-change="onChangeLearningResultDaySetting"
            :is-searchable="false"
            list-height="20em"
            place-holder=""
          ></select-box>
        </td>
      </tr>
    </table>
    <div class="flex">
      <div class="flex-row mr-2">
        <button type="button" @click="updatePharmacyProfile" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">登録する</button>
      </div>
      <div class="flex-row">
        <button type="button" @click="closePharmacyProfileDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
      </div>
    </div>
  </div>
  </template>
</modal-dialog>
<modal-dialog
  :is-visible="isEstablisheExpireDateDialog"
  :close="closeEstablishExpireDateAlert"
  width="60%"
>
  <template v-slot:header>
    警告
  </template>
  <template v-slot:default>
  <div class="w-full mb-6 p-6 flex items-center relative">
    <p class="text-red-700 font-bold">開設許可証の有効期限が切れています。<br>更新された開設許可証をアップロードして有効期限を更新してください。</p>
  </div>
  </template>
</modal-dialog>
<modal-dialog
  :is-visible="isTotpSettingDialog"
  :close="closeTotpSettingDialog"
  width="40%"
  :isLoading="isTotpSettingLoading"
>
  <template v-slot:header>
    二段階認証設定
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <div v-if="totpEnabled">
      <p class="mb-4">二段階認証は有効になっています。</p>
      <div class="mb-2">無効にするには、Google Authenticatorの認証コードを入力してください。</div>
      <text-box
        type="text"
        :value="totpCode"
        :on-change="onChangeTotpCode"
      ></text-box>
      <div class="flex">
        <div class="flex-row">
          <button type="button" @click="disableTotpConfirm" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">無効にする</button>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="!isTotpSetupStarted">
        <p class="mb-4">二段階認証は無効になっています。有効にすると、ログイン時にGoogle Authenticatorの認証コード入力が必要になります。</p>
        <button type="button" @click="startTotpSetup" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">設定する</button>
      </div>
      <div v-else>
        <p class="mb-2">Google Authenticatorで以下のQRコードを読み取ってください。</p>
        <div class="flex justify-center mb-4">
          <img :src="totpQrCode" class="w-48 h-48">
        </div>
        <p class="mb-2 text-sm text-gray-500">QRコードが読み取れない場合は、以下のキーを手動で入力してください。</p>
        <p class="mb-4 font-mono text-sm break-all">{{ totpSecret }}</p>
        <div class="mb-2">表示された6桁の認証コードを入力してください。</div>
        <text-box
          type="text"
          :value="totpCode"
          :on-change="onChangeTotpCode"
        ></text-box>
        <div class="flex">
          <div class="flex-row">
            <button type="button" @click="enableTotp" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">有効にする</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </template>
</modal-dialog>
</template>

